<template lang="pug">
  .bikeing-station-map-wrapper
    .add-user
      el-form(
        :model="form"
        ref="EditFieldForm"
        :rules="editFieldsInfoSettingsFormRules"
        @submit.native.prevent
      )
        //- h3.text-lg.font-semibold.mb-2 {{ $t('fields_info_settings.title') }}
        p.text-sm.text-gray-600.mb-4 {{ $t('fields_info_settings.actions.edit_description', { field: field.name }) }}
        //- div.mt-3.text-sm
        //-   span(style="color: #6aa84f") ■ Optimal
        //-   |  
        //-   span(style="color: #e69138") ■ Warning
        //-   |  
        //-   span(style="color: #cc0000") ■ Critical

        div(style="overflow-x: auto")
          //- (style="min-width: 960px; width: 100%")
          table.el-table__body
            thead
              tr
                th {{ $t('fields_info_settings.actions.label.info_type') }}
                th {{ $t('fields_info_settings.actions.label.info_type_unit') }}
                th(style="color: #6aa84f") {{ $t('fields_info_settings.actions.label.optimal_range_start') }}
                th(style="color: #6aa84f") {{ $t('fields_info_settings.actions.label.optimal_range_end') }}
                //- th(style="color: #e69138") {{ $t('fields_info_settings.actions.label.warning_range_start') }}
                //- th(style="color: #e69138") {{ $t('fields_info_settings.actions.label.warning_range_end') }}
                //- th(style="color: #cc0000") {{ $t('fields_info_settings.actions.label.critical_range_start') }}
                //- th(style="color: #cc0000") {{ $t('fields_info_settings.actions.label.critical_range_end') }}
            tbody
              tr(
                v-for="(fieldsInfoSettings, index) in form.fieldsInfoSettings"
                :key="fieldsInfoSettings.id"
                :class="index % 2 === 0 ? 'odd-row' : 'even-row'"
              )
                td(style="width: 170px")
                  el-form-item(:prop="'fieldsInfoSettings.' + index + '.info_type'")
                    el-input(
                      v-model="fieldsInfoSettings.info_type.toUpperCase()"
                      :name="'info_type_' + index"
                      size="small"
                      readonly
                      disabled
                    )
                td(style="width: 90px")
                  el-form-item(:prop="'fieldsInfoSettings.' + index + '.info_type_unit'")
                    el-input(
                      v-model="fieldsInfoSettings.info_type_unit"
                      :name="'info_type_unit_' + index"
                      size="small"
                      readonly
                      disabled
                    )
                td
                  el-form-item(:prop="'fieldsInfoSettings.' + index + '.range1s'")
                    el-input(
                      v-model.number="fieldsInfoSettings.range1s"
                      :name="'range1s_' + index"
                      size="small"
                      type="number"
                    )
                td
                  el-form-item(:prop="'fieldsInfoSettings.' + index + '.range1e'")
                    el-input(
                      v-model.number="fieldsInfoSettings.range1e"
                      :name="'range1e_' + index"
                      size="small"
                      type="number"
                    )
                //- td
                //-   el-form-item(:prop="'fieldsInfoSettings.' + index + '.range2s'")
                //-     el-input(
                //-       v-model.number="fieldsInfoSettings.range2s"
                //-       :name="'range2s_' + index"
                //-       size="small"
                //-       type="number"
                //-     )
                //- td
                //-   el-form-item(:prop="'fieldsInfoSettings.' + index + '.range2e'")
                //-     el-input(
                //-       v-model.number="fieldsInfoSettings.range2e"
                //-       :name="'range2e_' + index"
                //-       size="small"
                //-       type="number"
                //-     )
                //- td
                //-   el-form-item(:prop="'fieldsInfoSettings.' + index + '.range3s'")
                //-     el-input(
                //-       v-model.number="fieldsInfoSettings.range3s"
                //-       :name="'range3s_' + index"
                //-       size="small"
                //-       type="number"
                //-     )
                //- td
                //-   el-form-item(:prop="'fieldsInfoSettings.' + index + '.range3e'")
                //-     el-input(
                //-       v-model.number="fieldsInfoSettings.range3e"
                //-       :name="'range3e_' + index"
                //-       size="small"
                //-       type="number"
                //-     )


        el-row.text-center
          el-button.dark-green-btn.mt-5.pop-up-btn(
            v-if="form.fieldsInfoSettings.length > 0"
            @click="handleUpdateFieldInfoSettings()"
            :loading="loading"
          ) {{ $t('common.edit') }}

</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { customValidations } from "@utils/customValidators";
import { fieldsViewValidations } from "@utils/formValidations/fieldsViewValidations";
import { fieldInfoSettingsViewValidations } from "@utils/formValidations/fieldInfoSettingsViewValidations";
import { setObjectValues } from "@utils/generalUtils";

export default {
  name: "EditFieldInfoSettings",
  mixins: [
    fieldInfoSettingsViewValidations,
    fieldsViewValidations,
    customValidations
  ],

  data() {
    return {
      form: {
        fieldsInfoSettings: [],
      },
      originalFieldsInfoSettings: [],
      loading: false,
      editFieldsInfoSettingsFormRules: {},
      setObjectValues,
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("field", ["field"]),
  },

  async created() {
    await this.handleGetFormData();
    this.generateDynamicFieldRules(); // ← generate validation rules after loading
  },

  methods: {
    ...mapActions("field", ["getFieldInfoSettings", "updateFieldInfoSettings"]),
    ...mapMutations("dialog", ["hideEditFieldInfoSettingsDialog"]),
    ...mapMutations("field", ["setField", "setShouldFetchFields"]),

    async handleGetFormData() {
      const response = await this.getFieldInfoSettings(`?by_field_id=${this.field.id}`);

      this.form.fieldsInfoSettings = response.data.map((item) => ({
        id: item.id,
        info_type: item.info_type || '',
        info_type_unit: item.info_type_unit || '',
        range1s: parseFloat(item.range1s) || 0,
        range1e: parseFloat(item.range1e) || 0,
        range1color: item.range1color || '',
        range2s: parseFloat(item.range2s) || 0,
        range2e: parseFloat(item.range2e) || 0,
        range2color: item.range2color || '',
        range3s: parseFloat(item.range3s) || 0,
        range3e: parseFloat(item.range3e) || 0,
        range3color: item.range3color || ''
      }));

      this.originalFieldsInfoSettings = JSON.parse(JSON.stringify(this.form.fieldsInfoSettings));
    },

    handleUpdateFieldInfoSettings() {
      this.$refs.EditFieldForm.validate((valid) => {
        if (valid) {
          this.handleUpdateAllFieldInfoSettings();
        } else {
          this.$message.error(this.$t("common.validation_error"));
        }
      });
    },

    async handleUpdateAllFieldInfoSettings() {
      this.loading = true;

      const updates = [];

      for (let i = 0; i < this.form.fieldsInfoSettings.length; i++) {
        const current = this.form.fieldsInfoSettings[i];
        const original = this.originalFieldsInfoSettings[i];

        const hasChanges =
          current.range1s !== original.range1s ||
          current.range1e !== original.range1e ||
          current.range2s !== original.range2s ||
          current.range2e !== original.range2e ||
          current.range3s !== original.range3s ||
          current.range3e !== original.range3e ||
          current.range1color !== original.range1color ||
          current.range2color !== original.range2color ||
          current.range3color !== original.range3color;

        if (hasChanges) {
          if (isNaN(current.range1s) || isNaN(current.range1e)) {
            this.$message.error(this.$t('fields.errors.range_start_cannot_be_greaqsater'));
            this.loading = false;
            return;
          }

          if (current.range1s > current.range1e) {
            this.$message.error(this.$t('fields.errors.range_start_cannot_be_greater'));
            this.loading = false;
            return;
          }

          updates.push(this.updateFieldInfoSettings({
            id: current.id,
            range1s: current.range1s,
            range1e: current.range1e,
            range2s: current.range2s,
            range2e: current.range2e,
            range3s: current.range3s,
            range3e: current.range3e,
            range1color: current.range1color,
            range2color: current.range2color,
            range3color: current.range3color
          }));
        }
      }

      try {
        await Promise.all(updates);
        this.setShouldFetchFields(true);
        this.hideEditFieldInfoSettingsDialog();
      } catch (error) {
        console.error('Update failed:', error);
        this.$message.error(this.$t('common.update_error'));
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.odd-row {
  background-color: #f9f9f9;
}
.even-row {
  background-color: #ffffff;
}
.el-form-item {
  margin-bottom: 0;
}
.el-table__body th,
.el-table__body td {
  padding: 8px;
  text-align: center;
}

.add-user {
  font-family: inherit;       /* use the default app font */
  font-weight: 500;           /* semi-bold, similar to date label */
  font-size: 14px;            /* match surrounding font size */
  color: #2d3a4a;             /* slightly darker for visibility, not black */
  margin-bottom: 0.75rem;
}
</style>